import { Warning, CheckCircle, Info } from "@phosphor-icons/react";

export const money = (v) => `€${Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

export const Field = ({ label, hint, ...props }) => (
  <div>
    <label>{label}</label>
    <input {...props} />
    {hint ? <div className="text-[11px] text-white/40 mt-1">{hint}</div> : null}
  </div>
);

export const SelectField = ({ label, options, ...props }) => (
  <div>
    <label>{label}</label>
    <select {...props}>
      {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>
);

export function ResultPanel({ calc, tiles }) {
  if (!calc) return null;
  const r = calc.results;
  return (
    <div className="glass rounded-2xl p-6 space-y-5" data-testid="tax-result">
      <div className="eyebrow">Estimated relief</div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {tiles.map((t) => (
          <div key={t.key} className="rounded-xl bg-black/30 border border-white/5 p-4" data-testid={`tax-tile-${t.key}`}>
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/50">{t.label}</div>
            <div className="mono text-2xl mt-2" style={t.color ? { color: t.color } : undefined}>
              {t.pct ? `${(Number(r[t.key]) * 100).toFixed(0)}%` : t.money ? money(r[t.key]) : r[t.key]}
            </div>
          </div>
        ))}
      </div>

      {r.warnings?.length > 0 && (
        <div className="space-y-2">
          {r.warnings.map((w) => (
            <div key={w} className="flex items-start gap-2 text-sm rounded-lg px-3 py-2" style={{ background: "#FFB02014", border: "1px solid #FFB02044" }} data-testid="tax-warning">
              <Warning size={16} weight="fill" className="text-[#FFB020] mt-0.5 shrink-0" />
              <span className="text-white/80">{w}</span>
            </div>
          ))}
        </div>
      )}

      <div>
        <div className="eyebrow mb-2">Next steps</div>
        <ul className="space-y-1.5">
          {calc.next_steps.map((s) => (
            <li key={s} className="flex items-start gap-2 text-sm text-white/75">
              <CheckCircle size={16} weight="fill" className="text-[#00A86B] mt-0.5 shrink-0" /> {s}
            </li>
          ))}
        </ul>
      </div>

      <div className="flex items-start gap-2 text-xs text-white/50 border-t border-white/5 pt-4">
        <Info size={14} className="mt-0.5 shrink-0" /> {calc.disclaimer}
      </div>
    </div>
  );
}
